import { useState } from "react";
import {
  RankingBoardSaveButton,
  RankingBoardSettingBody,
  RankingBoardSettingCloseButton,
  RankingBoardSettingContentWrapper,
  RankingBoardSettingHeader,
  RankingBoardSettingPageText,
  RankingBoardSettingTitle,
  RankingBoardSettingWrapper,
  EditBaseDropBox,
  EditBaseDropBoxItem,
  EditBaseDropBoxItemWrapper,
  EditBaseInputBox,
  EditBaseItemWrapper,
  EditEntryCheckbox,
} from "./styles";

export const RankingBoardSetting = ({
  setIsRankingBoardSettingOpen,
}: {
  setIsRankingBoardSettingOpen: (isRankingBoardSettingOpen: boolean) => void;
}) => {
  const [openItem1, setOpenItem1] = useState(false);
  const [openItem2, setOpenItem2] = useState(false);
  const [openItem3, setOpenItem3] = useState(false);
  const [openItem4, setOpenItem4] = useState(false);
  const [openItem5, setOpenItem5] = useState(false);
  const [openItem6, setOpenItem6] = useState(false);

  const [item1, setItem1] = useState(localStorage.getItem("item1") || "season");
  const [item2, setItem2] = useState(localStorage.getItem("item2") || "month");
  const [item3, setItem3] = useState(localStorage.getItem("item3") || "week");
  const [item4, setItem4] = useState(localStorage.getItem("item4") || "entry");
  const [item5, setItem5] = useState(localStorage.getItem("item5") || "itm");
  const [item6, setItem6] = useState(localStorage.getItem("item6") || "trophy");

  const [isNotAutoNextPage, setIsNotAutoNextPage] = useState(
    localStorage.getItem("isNotAutoNextPage") === "true",
  );

  const [isNotAutoPage2, setIsNotAutoPage2] = useState(
    localStorage.getItem("isNotAutoPage2") === "true",
  );

  const itemList = [
    { name: "매장랭킹", value: "season" },
    { name: "월간랭킹", value: "month" },
    { name: "주간랭킹", value: "week" },
    { name: "엔트리왕", value: "entry" },
    { name: "ITM마스터", value: "itm" },
    { name: "챔피언헌터", value: "trophy" },
  ];

  const handleSave = () => {
    localStorage.setItem("item1", item1);
    localStorage.setItem("item2", item2);
    localStorage.setItem("item3", item3);
    localStorage.setItem("item4", item4);
    localStorage.setItem("item5", item5);
    localStorage.setItem("item6", item6);
    localStorage.setItem("isNotAutoNextPage", isNotAutoNextPage.toString());
    localStorage.setItem("isNotAutoPage2", isNotAutoPage2.toString());
    alert("저장되었습니다.");
    setIsRankingBoardSettingOpen(false);
  };

  return (
    <>
      <RankingBoardSettingWrapper
        onClick={() => setIsRankingBoardSettingOpen(false)}
      />
      <RankingBoardSettingContentWrapper>
        <RankingBoardSettingHeader>
          <RankingBoardSettingTitle>랭킹 보드 설정</RankingBoardSettingTitle>
          <RankingBoardSettingCloseButton
            src="/image-web/tournament/close.svg"
            onClick={() => setIsRankingBoardSettingOpen(false)}
          />
        </RankingBoardSettingHeader>
        <RankingBoardSettingBody>
          <RankingBoardSettingPageText>
            {"<1페이지>"}
          </RankingBoardSettingPageText>
          <EditBaseItemWrapper>
            <div className="title">첫번째 랭킹</div>
            <EditBaseInputBox type={"back"}>
              <EditBaseDropBox
                onClick={() => {
                  setOpenItem1(!openItem1);
                }}
              >
                <div className="value">
                  {itemList.find((item) => item.value === item1)?.name}
                </div>
                <img src="/image-web/tournament/drop-down.svg" alt="" />
                {openItem1 && (
                  <EditBaseDropBoxItemWrapper>
                    {itemList.map((item, index) => (
                      <EditBaseDropBoxItem
                        key={index}
                        onClick={() => {
                          setItem1(item.value);
                        }}
                      >
                        <span>{item.name}</span>
                        {item1 === item.value && (
                          <img src="/image-web/tournament/check.svg" alt="" />
                        )}
                      </EditBaseDropBoxItem>
                    ))}
                  </EditBaseDropBoxItemWrapper>
                )}
              </EditBaseDropBox>
            </EditBaseInputBox>
          </EditBaseItemWrapper>
          <EditBaseItemWrapper>
            <div className="title">두번째 랭킹</div>
            <EditBaseInputBox type={"back"}>
              <EditBaseDropBox
                onClick={() => {
                  setOpenItem2(!openItem2);
                }}
              >
                <div className="value">
                  {itemList.find((item) => item.value === item2)?.name}
                </div>
                <img src="/image-web/tournament/drop-down.svg" alt="" />
                {openItem2 && (
                  <EditBaseDropBoxItemWrapper>
                    {itemList.map((item, index) => (
                      <EditBaseDropBoxItem
                        key={index}
                        onClick={() => {
                          setItem2(item.value);
                        }}
                      >
                        <span>{item.name}</span>
                        {item2 === item.value && (
                          <img src="/image-web/tournament/check.svg" alt="" />
                        )}
                      </EditBaseDropBoxItem>
                    ))}
                  </EditBaseDropBoxItemWrapper>
                )}
              </EditBaseDropBox>
            </EditBaseInputBox>
          </EditBaseItemWrapper>
          <EditBaseItemWrapper>
            <div className="title">세번째 랭킹</div>
            <EditBaseInputBox type={"back"}>
              <EditBaseDropBox
                onClick={() => {
                  setOpenItem3(!openItem3);
                }}
              >
                <div className="value">
                  {itemList.find((item) => item.value === item3)?.name}
                </div>
                <img src="/image-web/tournament/drop-down.svg" alt="" />
                {openItem3 && (
                  <EditBaseDropBoxItemWrapper>
                    {itemList.map((item, index) => (
                      <EditBaseDropBoxItem
                        key={index}
                        onClick={() => {
                          setItem3(item.value);
                        }}
                      >
                        <span>{item.name}</span>
                        {item3 === item.value && (
                          <img src="/image-web/tournament/check.svg" alt="" />
                        )}
                      </EditBaseDropBoxItem>
                    ))}
                  </EditBaseDropBoxItemWrapper>
                )}
              </EditBaseDropBox>
            </EditBaseInputBox>
          </EditBaseItemWrapper>
          <RankingBoardSettingPageText>
            {"<2페이지>"}
            <EditEntryCheckbox>
              <input
                type="checkbox"
                checked={!isNotAutoPage2}
                onChange={(e) => setIsNotAutoPage2(!e.target.checked)}
              />
              {!isNotAutoPage2 && (
                <img
                  src="/image-web/tournament/checked-icon.svg"
                  alt="checked"
                />
              )}
            </EditEntryCheckbox>
          </RankingBoardSettingPageText>
          <EditBaseItemWrapper>
            <div className="title">첫번째 랭킹</div>
            <EditBaseInputBox type={"back"}>
              <EditBaseDropBox
                onClick={() => {
                  setOpenItem4(!openItem4);
                }}
              >
                <div className="value">
                  {itemList.find((item) => item.value === item4)?.name}
                </div>
                <img src="/image-web/tournament/drop-down.svg" alt="" />
                {openItem4 && (
                  <EditBaseDropBoxItemWrapper>
                    {itemList.map((item, index) => (
                      <EditBaseDropBoxItem
                        key={index}
                        onClick={() => {
                          setItem4(item.value);
                        }}
                      >
                        <span>{item.name}</span>
                        {item4 === item.value && (
                          <img src="/image-web/tournament/check.svg" alt="" />
                        )}
                      </EditBaseDropBoxItem>
                    ))}
                  </EditBaseDropBoxItemWrapper>
                )}
              </EditBaseDropBox>
            </EditBaseInputBox>
          </EditBaseItemWrapper>
          <EditBaseItemWrapper>
            <div className="title">두번째 랭킹</div>
            <EditBaseInputBox type={"back"}>
              <EditBaseDropBox
                onClick={() => {
                  setOpenItem5(!openItem5);
                }}
              >
                <div className="value">
                  {itemList.find((item) => item.value === item5)?.name}
                </div>
                <img src="/image-web/tournament/drop-down.svg" alt="" />
                {openItem5 && (
                  <EditBaseDropBoxItemWrapper>
                    {itemList.map((item, index) => (
                      <EditBaseDropBoxItem
                        key={index}
                        onClick={() => {
                          setItem5(item.value);
                        }}
                      >
                        <span>{item.name}</span>
                        {item5 === item.value && (
                          <img src="/image-web/tournament/check.svg" alt="" />
                        )}
                      </EditBaseDropBoxItem>
                    ))}
                  </EditBaseDropBoxItemWrapper>
                )}
              </EditBaseDropBox>
            </EditBaseInputBox>
          </EditBaseItemWrapper>
          <EditBaseItemWrapper>
            <div className="title">세번째 랭킹</div>
            <EditBaseInputBox type={"back"}>
              <EditBaseDropBox
                onClick={() => {
                  setOpenItem6(!openItem6);
                }}
              >
                <div className="value">
                  {itemList.find((item) => item.value === item6)?.name}
                </div>
                <img src="/image-web/tournament/drop-down.svg" alt="" />
                {openItem6 && (
                  <EditBaseDropBoxItemWrapper>
                    {itemList.map((item, index) => (
                      <EditBaseDropBoxItem
                        key={index}
                        onClick={() => {
                          setItem6(item.value);
                        }}
                      >
                        <span>{item.name}</span>
                        {item6 === item.value && (
                          <img src="/image-web/tournament/check.svg" alt="" />
                        )}
                      </EditBaseDropBoxItem>
                    ))}
                  </EditBaseDropBoxItemWrapper>
                )}
              </EditBaseDropBox>
            </EditBaseInputBox>
          </EditBaseItemWrapper>
          <EditBaseItemWrapper>
            <div className="title">자동 페이지 이동</div>
            <EditEntryCheckbox>
              <input
                type="checkbox"
                checked={!isNotAutoNextPage}
                onChange={(e) => setIsNotAutoNextPage(!e.target.checked)}
              />
              {!isNotAutoNextPage && (
                <img
                  src="/image-web/tournament/checked-icon.svg"
                  alt="checked"
                />
              )}
            </EditEntryCheckbox>
          </EditBaseItemWrapper>
          <RankingBoardSaveButton onClick={handleSave}>
            저장
          </RankingBoardSaveButton>
        </RankingBoardSettingBody>
      </RankingBoardSettingContentWrapper>
    </>
  );
};
